export default "__VITE_ASSET__Dj96Lq0q__"